"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const zod_1 = require("zod");
const react_hook_form_1 = require("react-hook-form");
const zod_2 = require("@hookform/resolvers/zod");
const react_router_dom_1 = require("react-router-dom");
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_i18next_1 = require("react-i18next");
const classnames_1 = __importDefault(require("classnames"));
const reactstrap_1 = require("reactstrap");
const SearchContextProvider_1 = require("../../../../../shared/contexts/SearchContextProvider");
const AccessibilityContext_1 = require("../../../../consulta-acessibilidade/contexts/AccessibilityContext");
const AppInfo_1 = __importDefault(require("../../../../../shared/components/AppInfo"));
const AutoCompleteSuggestions_1 = __importDefault(require("../AutoCompleteSuggestions"));
const Button_1 = __importDefault(require("../../../../consulta-acessibilidade/Button"));
const AdvancedSearchFilters_1 = __importDefault(require("./AdvancedSearchFilters"));
const GlobalEvent_1 = __importDefault(require("../../../../../shared/events/GlobalEvent"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const schema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.object({
        input: zod_1.z.string().min(1, "CampoBuscaObrigatorio"),
        option: zod_1.z.string().min(1, "É necessario informar a opção de pesquisa."),
        condition: zod_1.z.string().optional(),
    })),
    termType: zod_1.z.enum(["P", "E", "I"], {
        required_error: "Você deve selecionar uma opção", // Mensagem de erro se não for selecionado
        invalid_type_error: "Tipo inválido"
    }),
});
const AdvancedSearch = ({ autoCompleteTerms, loading, error, onChangeSearch }) => {
    const [isOpenFilters, setIsOpenFilters] = (0, react_1.useState)(false);
    const location = (0, react_router_dom_1.useLocation)();
    const { search, loadingSearch, lastSearchForm, researchDone } = (0, SearchContextProvider_1.useSearchContext)();
    const searchParams = new URLSearchParams(location.search);
    const { t } = (0, react_i18next_1.useTranslation)();
    const [filtersOptionsInitialData, setFilterOptionsInitialData] = (0, react_1.useState)();
    const { control, register, handleSubmit, watch, reset, formState: { errors }, } = (0, react_hook_form_1.useForm)({
        resolver: (0, zod_2.zodResolver)(schema),
        defaultValues: {
            items: [{ input: '', option: 'LIVRE', }],
            termType: 'P'
        }
    });
    const data = watch();
    // Escutando o evento global
    (0, react_1.useEffect)(() => {
        const handleClearSearch = () => {
            reset({ items: [{ input: '', option: 'LIVRE', }], termType: 'P' });
            setFilterOptionsInitialData({
                libraries: [],
                typeOfWork: [],
                collection: [],
                publicationPlace: undefined,
                language: undefined,
                internLocation: undefined,
                physicalDesc: undefined,
                order: undefined,
                itemsPerPage: undefined,
                publicationYear: undefined,
                compPublicationYear: undefined,
                virtualLib: 'N',
                finalPublicationYear: undefined
            });
        };
        GlobalEvent_1.default.on("CLEAR_SEARCH", handleClearSearch);
        // Cleanup: Remover o evento ao desmontar o componente
        return () => {
            GlobalEvent_1.default.off("CLEAR_SEARCH", handleClearSearch);
        };
    }, [reset, setFilterOptionsInitialData]);
    (0, react_1.useEffect)(() => {
        if (lastSearchForm) {
            if (lastSearchForm.termo_pesquisa) {
                const defaultValues = {
                    items: [],
                    termType: 'E'
                };
                defaultValues.items.push({
                    input: lastSearchForm.termo_pesquisa || '',
                    option: lastSearchForm.coluna_um || '',
                    condition: lastSearchForm.condicao_um || undefined,
                });
                if (lastSearchForm.termo_pesquisa_dois) {
                    defaultValues.items.push({
                        input: lastSearchForm.termo_pesquisa_dois || '',
                        option: lastSearchForm.coluna_dois || '',
                        condition: lastSearchForm.condicao_dois || undefined,
                    });
                }
                if (lastSearchForm.termo_pesquisa_tres) {
                    defaultValues.items.push({
                        input: lastSearchForm.termo_pesquisa_tres || '',
                        option: lastSearchForm.coluna_tres || '',
                    });
                }
                reset(defaultValues);
            }
            let initialData = {};
            let hasFilterOptions = false;
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.bib_virtual) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { bib_virtual: lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.bib_virtual });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.biblioteca) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { libraries: lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.biblioteca.trim().replace(/,$/, '').split(',') });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.cod_tipo_obra) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { typeOfWork: lastSearchForm.cod_tipo_obra.trim().replace(/,$/, '').split(',') });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.colecao) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { collection: lastSearchForm.colecao.trim().replace(/,$/, '').split(',') });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.local) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { publicationPlace: lastSearchForm.local });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.idioma) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { language: lastSearchForm.idioma });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.local_interna) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { internLocation: lastSearchForm.local_interna });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.categoria) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { physicalDesc: lastSearchForm.categoria });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.ordenacao) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { order: lastSearchForm.ordenacao });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.perPage) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { itemsPerPage: lastSearchForm.perPage });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.ano_publicacao) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { publicationYear: lastSearchForm.ano_publicacao });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.comp_ano_publicacao) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { compPublicationYear: lastSearchForm.comp_ano_publicacao });
            }
            if (lastSearchForm === null || lastSearchForm === void 0 ? void 0 : lastSearchForm.ano_publicacao_final) {
                hasFilterOptions = true;
                initialData = Object.assign(Object.assign({}, initialData), { finalPublicationYear: lastSearchForm.ano_publicacao_final });
            }
            setFilterOptionsInitialData(initialData);
            setIsOpenFilters(hasFilterOptions);
        }
    }, [lastSearchForm, reset]);
    const [filterOptions, setFilterOptions] = (0, react_1.useState)({});
    const items = watch('items');
    const { fields, append, remove } = (0, react_hook_form_1.useFieldArray)({
        control,
        // @ts-ignore
        name: "items",
    });
    const { searchInputRef } = (0, AccessibilityContext_1.useAccessibilityContext)();
    const formRef = (0, react_1.useRef)(null);
    const conditions = [
        { label: t('AND'), value: 'AND', intermediario: false },
        { label: t('OR'), value: 'OR', intermediario: false },
        { label: t('NOT'), value: 'NOT', intermediario: false },
        { label: t('AFT'), value: 'AFT', intermediario: true },
        { label: t('BEF'), value: 'BEF', intermediario: true },
        { label: t('PRO'), value: 'PRO', intermediario: true },
    ];
    const options = [
        { label: t('LIVRE'), value: 'LIVRE' },
        { label: t('TITULO'), value: 'TITULO' },
        { label: t('ASSUNTO'), value: 'ASSUNTO' },
        { label: t('AUTOR'), value: 'AUTOR' },
    ];
    const handleSearch = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const form = {};
        const map_keys = {
            input: [
                'termo_pesquisa',
                'termo_pesquisa_dois',
                'termo_pesquisa_tres'
            ],
            condition: {
                1: 'condicao_um',
                2: 'condicao_dois',
            },
            column: [
                'coluna_um',
                'coluna_dois',
                'coluna_tres'
            ]
        };
        const map_keys_params = {
            input: [
                'q',
                'q2',
                'q3'
            ],
            condition: {
                1: 'condition',
                2: 'condition2',
            },
            column: [
                'for',
                'for2',
                'for3'
            ]
        };
        const params = {};
        data.items.forEach((item, index) => {
            form[map_keys.input[index]] = item.input;
            form[map_keys.column[index]] = item.option;
            params[map_keys_params.input[index]] = item.input;
            params[map_keys_params.column[index]] = item.option;
            if (item.condition) {
                form[map_keys.condition[index]] = item.condition;
                params[map_keys_params.condition[index]] = item.condition;
            }
        });
        form.biblioteca = ((_a = filterOptions.libraries) === null || _a === void 0 ? void 0 : _a.length) ? filterOptions.libraries.join(',') + ',' : filterOptions.libraries;
        if (form.biblioteca)
            params.id_biblioteca = form.biblioteca;
        form.cod_tipo_obra = ((_b = filterOptions.typeOfWork) === null || _b === void 0 ? void 0 : _b.length) ? filterOptions.typeOfWork.join(',') + ',' : filterOptions.typeOfWork;
        if (form.cod_tipo_obra)
            params.tipo_obra = form.cod_tipo_obra;
        form.colecao = ((_c = filterOptions.collection) === null || _c === void 0 ? void 0 : _c.length) ? filterOptions.collection.join(',') : filterOptions.collection;
        if (form.colecao)
            params.id_colecao = form.colecao;
        form.tipo_termos = data.termType;
        if (form.tipo_termos)
            params.keyword_type = form.tipo_termos;
        form.ano_publicacao = filterOptions.publicationYear;
        if (form.ano_publicacao)
            params.ano_publicacao = form.ano_publicacao;
        form.ano_publicacao_final = filterOptions.finalPublicationYear;
        if (form.ano_publicacao_final)
            params.ano_publicacao_final = form.ano_publicacao_final;
        form.comp_ano_publicacao = filterOptions.compPublicationYear;
        if (form.comp_ano_publicacao)
            params.comp_ano_publicacao = form.comp_ano_publicacao;
        form.idioma = filterOptions.language;
        if (form.idioma)
            params.idioma = form.idioma;
        form.local = filterOptions.publicationPlace; // cod_local
        if (form.local)
            params.local = form.local;
        form.categoria = filterOptions.physicalDesc; //cod_categ
        if (form.categoria)
            params.categoria = form.categoria;
        form.ordenacao = filterOptions.order;
        if (form.ordenacao)
            params.ordenacao = form.ordenacao;
        form.bib_virtual = filterOptions.virtualLib;
        if (form.bib_virtual)
            params.cr = form.bib_virtual;
        form.perPage = filterOptions.itemsPerPage;
        if (form.perPage)
            params.perPage = form.perPage;
        form.local_interna = filterOptions.internLocation;
        if (form.local_interna)
            params.local_interna = form.local_interna;
        yield search(form, params);
    });
    return (react_1.default.createElement(react_bootstrap_1.Form, { ref: formRef, onSubmit: handleSubmit(handleSearch) },
        react_1.default.createElement(react_bootstrap_1.Row, { className: "content__left__input px-3" },
            react_1.default.createElement(react_bootstrap_1.Col, { md: "10", xs: "12" }, fields.map((field, index) => {
                var _a, _b, _c, _d, _e, _f;
                return (react_1.default.createElement("div", { key: field.id },
                    react_1.default.createElement(react_bootstrap_1.Row, { className: `w-100 ${index !== 0 &&
                            'additional_search_input pl-sm-0 pl-2 pr-sm-0 pr-2'}`, key: `row-termo-${index}` },
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: "1", xs: "12", className: "input-holder mt-3 text-sm-right text-center" }, (index > 0) && (react_1.default.createElement("div", null,
                            react_1.default.createElement("button", { className: "btn-generic--primeiro nao d-sm-inline-block d-none mt-3", title: t('Remover'), type: "button", onClick: () => remove(index) },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "times" })),
                            react_1.default.createElement("button", { style: { marginTop: '-30px' }, className: "btn-generic--primeiro nao d-sm-none d-block", type: "button", onClick: () => remove(index) },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "times", className: "s15 mr-2" }),
                                react_1.default.createElement("span", { className: "s14" },
                                    ' ',
                                    t('Remover'),
                                    ' '))))),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: "2", xs: "12", className: "input-holder mt-3" },
                            react_1.default.createElement("div", { className: "rotulo" }, t('TipoPesquisas')),
                            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: `items.${index}.option`, render: ({ field }) => {
                                    var _a, _b;
                                    return (react_1.default.createElement(react_bootstrap_1.FormControl, { as: "select", className: 'form-control', value: field.value, onChange: (e) => {
                                            if (onChangeSearch) {
                                                const { value } = e.target;
                                                const payload = {
                                                    searchTerm: data.items[index].input,
                                                    searchOption: value
                                                };
                                                onChangeSearch(payload, index);
                                            }
                                            return field.onChange(e);
                                        }, isInvalid: ((_b = (_a = errors === null || errors === void 0 ? void 0 : errors.items) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.option) !== undefined }, options.map(item => (react_1.default.createElement("option", { key: `opt-${item.value}`, value: item.value }, item.label)))));
                                } }),
                            ((_b = (_a = errors.items) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.option) ? react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t(errors.items[index].option.message)) : ''),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: "6", xs: "12", className: "input-holder mt-3" },
                            react_1.default.createElement("div", { className: 'rotulo' }, t('CampoBusca')),
                            react_1.default.createElement(react_bootstrap_1.Row, null,
                                react_1.default.createElement(react_bootstrap_1.Col, { xs: '10', md: '11' },
                                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: `items.${index}.input`, render: ({ field }) => {
                                            var _a, _b;
                                            return (react_1.default.createElement(react_bootstrap_1.FormControl, { value: field.value, onChange: (e) => {
                                                    if (onChangeSearch) {
                                                        const { value } = e.target;
                                                        const payload = {
                                                            searchTerm: value,
                                                            searchOption: data.items[index].option
                                                        };
                                                        onChangeSearch(payload, index);
                                                    }
                                                    return field.onChange(e);
                                                }, isInvalid: ((_b = (_a = errors === null || errors === void 0 ? void 0 : errors.items) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.input) !== undefined, ref: (e) => {
                                                    // register(`items.${index}.input`).ref(e);
                                                    searchInputRef.current = e;
                                                }, type: "search", className: "rad10 b-tema20 cortxt foco form-control", placeholder: t('DigiteSuaBuscaAqui'), autoComplete: "off", list: `suggestions-pesquisa-avancada-${index}` }));
                                        } }),
                                    ((_d = (_c = errors.items) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.input) ? react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t(errors.items[index].input.message)) : ''),
                                index === 0 ? (react_1.default.createElement(react_bootstrap_1.Col, { className: 'd-flex justify-content-start align-items-center', xs: '2', md: '1' },
                                    react_1.default.createElement(AppInfo_1.default, { message: t('MsgHelpIcon') }))) : ''),
                            react_1.default.createElement(AutoCompleteSuggestions_1.default, { autoCompleteTerms: autoCompleteTerms !== null ? autoCompleteTerms[index] : [], dataListId: `suggestions-pesquisa-avancada-${index}` })),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: "3", xs: "12", className: "mt-3 input-holder align-self-end" }, 
                        // eslint-disable-next-line no-nested-ternary
                        index < 2 ? (index === items.length - 1 ? (react_1.default.createElement("div", { className: "d-inline-block" },
                            react_1.default.createElement("button", { type: "button", className: "btn-generic--segundo ml-0 ", onClick: () => append({
                                    input: '',
                                    condition: 'AND',
                                    option: 'LIVRE'
                                }) },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "plus", className: "mr-2" }),
                                ' ',
                                t('AdicionarTermo')))) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "rotulo" }, t('Condicionais')),
                            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: `items.${index}.condition`, render: ({ field }) => {
                                    var _a, _b;
                                    return (react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ as: "select", className: "form-control" }, field, { isInvalid: ((_b = (_a = errors === null || errors === void 0 ? void 0 : errors.items) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.condition) !== undefined, style: {
                                            width: '70%',
                                            display: 'inline',
                                        } }),
                                        react_1.default.createElement("option", { value: "-1", disabled: true }),
                                        conditions.map((condicao) => (react_1.default.createElement("option", { key: `cond-${condicao.value}`, value: condicao.value }, condicao.label)))));
                                } }),
                            ((_f = (_e = errors.items) === null || _e === void 0 ? void 0 : _e[index]) === null || _f === void 0 ? void 0 : _f.condition) ? react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t(errors.items[index].condition.message)) : ''))) : ''))));
            })),
            react_1.default.createElement(react_bootstrap_1.Col, { md: "2", xs: "12", className: (0, classnames_1.default)(' mt-3 align-self-end pb-0', { 'mb-4': error }) },
                react_1.default.createElement(Button_1.default, { title: "Pesquisar", icon: "search", variant: 'primeiro ml-0 btn-responsivo', type: "submit", disabled: loading }))),
        react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3 ml-2 px-3" },
            react_1.default.createElement(react_bootstrap_1.Col, { sm: { size: 11, offset: 1 }, xs: "12" },
                react_1.default.createElement(reactstrap_1.FormGroup, { tag: "fieldset" },
                    react_1.default.createElement("span", { className: "cortxt s14 f500 r10" },
                        t('TipoTermos'),
                        ":"),
                    react_1.default.createElement("div", { className: "d-lg-inline ml-lg-5 d-md-block mt-2" },
                        react_1.default.createElement(reactstrap_1.Label, { check: true, className: "preto70 s14 hover1" },
                            react_1.default.createElement(react_hook_form_1.Controller, { control: control, render: ({ field }) => (react_1.default.createElement(reactstrap_1.Input, Object.assign({}, field, { type: "radio", className: "checkNovo", value: "P", defaultChecked: field.value === "P" }))), name: "termType" }),
                            t('PalavraLivre'))),
                    react_1.default.createElement("div", { className: "d-lg-inline ml-lg-5 d-md-block mt-2" },
                        react_1.default.createElement(reactstrap_1.Label, { check: true, className: "preto70 s14 hover1" },
                            react_1.default.createElement(react_hook_form_1.Controller, { control: control, render: ({ field }) => (react_1.default.createElement(reactstrap_1.Input, Object.assign({}, field, { type: "radio", className: "checkNovo", value: "E", defaultChecked: field.value === "E" }))), name: "termType" }),
                            t('ExatamenteIgual'))),
                    react_1.default.createElement("div", { className: "d-lg-inline ml-lg-5 d-md-block mt-2" },
                        react_1.default.createElement(reactstrap_1.Label, { check: true, className: "preto70 s14 hover1" },
                            react_1.default.createElement(react_hook_form_1.Controller, { control: control, render: ({ field }) => (react_1.default.createElement(reactstrap_1.Input, Object.assign({}, field, { type: "radio", className: "checkNovo", value: "I", defaultChecked: field.value === "I" }))), name: "termType" }),
                            t('TermoInicial'))))),
            react_1.default.createElement(react_bootstrap_1.Col, { className: "d-flex justify-content-center align-items-center p-2", md: "12" },
                react_1.default.createElement("button", { type: "button", className: "btn-generic--segundo ml-0 ", onClick: _ => setIsOpenFilters(!isOpenFilters) },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: (isOpenFilters ? free_solid_svg_icons_1.faMinus : free_solid_svg_icons_1.faPlus), className: "mr-2" }),
                    ' ',
                    t(isOpenFilters ? 'MenosOpcoesDeConsulta' : 'MaisOpcoesDeConsulta'))),
            react_1.default.createElement(react_bootstrap_1.Col, { className: 'px-3', md: "12" },
                react_1.default.createElement(AdvancedSearchFilters_1.default, { input: filtersOptionsInitialData, onChange: (data) => {
                        setFilterOptions(data);
                    }, isOpen: isOpenFilters, setIsOpen: setIsOpenFilters })))));
};
exports.default = AdvancedSearch;
